import StandalonePage from 'components/standalone-page/standalone-page.component';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SmsSignupForm from './sms-signup-form/sms-signup-form.component';
import { useSelector } from 'react-redux';
import { selectClientName } from 'redux/config/config.selectors';

const SmsSignup = () => {
  const { t } = useTranslation();
  const clientName = useSelector(selectClientName);

  return (
    <StandalonePage
      title={t('signUp.title')}
      description={t('activationPage.description.phoneOnly', { clientName })}
    >
      <SmsSignupForm />
    </StandalonePage>
  );
};

export default SmsSignup;
